import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserInitials, getUserDisplayName } from '../utils/userUtils';
import './Header.css';

const Header = ({ user }) => {
  const navigate = useNavigate();
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src="/images/logo-gradient.svg" alt="Logo" className="logo-gradient" />
          <span className="logo-divider"></span>
          <span className="logo-text">Language Buddy</span>
        </div>

        <div className="header-right">
          <button
            type="button"
            className="my-dashboard-link"
            onClick={() => navigate('/dashboard')}
          >
            Dashboard
          </button>
          <div className="user-avatar" title={getUserDisplayName(user)}>
            {getUserInitials(user)}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
